import Vue from 'vue';
import Vuex from 'vuex';
import Login from '@/store/login';
import School from '@/store/school';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
     login: Login,
     school: School
  }
});
